// extracted by mini-css-extract-plugin
export default {"container":"MK-z","dimension":"NK-z","dimensionLabels":"OK-z"};